<script>
  export let text;
  export let forId;
  export let classes = "ml-4";
</script>

<label
    for={forId}
    class={`${classes} mb-0 text-base font-sans font-light text-neutral-200`}
  >
  {text}
</label>
